/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Color_Role_FontInputs */

const en_enum_color_role_font = /** @type {(inputs: Enum_Color_Role_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Font`)
};

const de_enum_color_role_font = /** @type {(inputs: Enum_Color_Role_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Font`)
};

/**
* | output |
* | --- |
* | "Role Font" |
*
* @param {Enum_Color_Role_FontInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_color_role_font = /** @type {((inputs?: Enum_Color_Role_FontInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Color_Role_FontInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_color_role_font(inputs)
	return de_enum_color_role_font(inputs)
});